import * as React from 'react';
import * as sunBlue from '../../../lotties/daily_lesson/sun_blue.json';
import * as sunGreen from '../../../lotties/daily_lesson/sun_green.json';
import * as sunPink from '../../../lotties/daily_lesson/sun_pink.json';
import * as sunYellow from '../../../lotties/daily_lesson/sun_yellow.json';
import { DailyLessonLottieIcon } from './daily_lesson_lottie_icon';
const ANIMATION_BY_COLOR = {
    green: sunGreen,
    pink: sunPink,
    yellow: sunYellow,
    blue: sunBlue,
};
export const DailyLessonSunLottieIcon = ({ volumeColor, classObject }) => {
    return React.createElement(DailyLessonLottieIcon, { animationData: ANIMATION_BY_COLOR[volumeColor], classObject: classObject });
};
